import type React from 'react';

import { Route, Routes } from 'react-router';
import type { BrainAtlasType, MultiLang } from '../config';
import CoverPage from '../custom/CoverPage';
import RelatedLink from '../custom/RelatedLink';
import Xoonips from '../xoonips/Xoonips';
import XoonipsTop from '../xoonips/XoonipsTop';
import XoopsPathRedirect from './XoopsPathRedirect';

interface Props {
    lang: MultiLang;
    type: BrainAtlasType;
    isHtml: boolean;
    isLink: boolean;
}

const MainContent: React.FC<Props> = (props) => {
    const { lang, type, isHtml, isLink } = props;
    return (
        <div className="mainContent">
            {isHtml ? (
                isLink ? (
                    <RelatedLink lang={lang} type={type} />
                ) : (
                    <CoverPage lang={lang} type={type} />
                )
            ) : (
                <Routes>
                    <Route index element={<XoonipsTop lang={lang} type={type} />} />
                    <Route path="modules/xoonips/*" element={<Xoonips lang={lang} type={type} />} />
                    <Route path="*" element={<XoopsPathRedirect lang={lang} />} />
                </Routes>
            )}
        </div>
    );
};

export default MainContent;
